module.exports = __webpack_public_path__ + "img/f1-4.97545d29.png";